import api from "@/utils/http";

/**
 功能：
 time: 2026/1/5 11:06
 **/
export function getLogsConfig() {
    return api.get('/admin/logs/getSetConfig')
}

/**
 功能：
 time: 2026/1/5 11:42
 **/
export function getLogsList(data) {
    return api.post('/admin/logs/getList', data)
}


